import {
  TEXT_SIZE,
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
  TEXT_HEADING_LEVEL,
} from "@/bit/components/next13.components.text";

export const colors = {
  color_emp__blue_dark: "#0B2739",
  color_gp__grey: "#2A2A3C",
  color_gp__grey2: "#EEEEEE",
  color_gp__grey5: "#86888C",
  color_gp__grey4: "#999999",
  color_gp__grey6: "#313235",
  color_gp__blue: "#019DF4",
};

export const grid = {
  max_width_xs: "328",
  width_xs: "100%",
  grid_gap_xs: "8",

  breakpoint_sm: "768",
  breakpoint_md: "1224",
  breakpoint_lg: "1280",
  breakpoint_xl: "1512",
};

export const defaultTitleStyles = {
  size: TEXT_SIZE.TITLE1,
  color: TEXT_COLOR.WHITE,
  kind: TEXT_KIND.HEADING,
  align: TEXT_ALIGN.LEFT,
  fontType: TEXT_FONT_WEIGHT.BOLD,
  level: TEXT_HEADING_LEVEL.H2,
};

export const defaultSubTitleStyles = {
  size: TEXT_SIZE.TITLE2,
  color: TEXT_COLOR.WHITE,
  kind: TEXT_KIND.HEADING,
  align: TEXT_ALIGN.LEFT,
  fontType: TEXT_FONT_WEIGHT.REGULAR,
  level: TEXT_HEADING_LEVEL.H3,
};
